import React from 'react'
import { styled } from 'styled-components'
import {AiOutlineArrowRight} from 'react-icons/ai'
import { Link } from 'react-router-dom'
import { newsContent } from '../../utils/contants'
import useChangeSlider from '../../hooks/useChangeSlides'
import {MdOutlineKeyboardArrowLeft,MdOutlineKeyboardArrowRight} from 'react-icons/md'

const NewsSlider = () => {
   
    //Provide 4000ms ~ 4s timeFrame for the slider to change
    const [currentSlide, setSlideIndex] = useChangeSlider(4000);

  return (
    <Container>
        <div className="slides">
            <input type="radio" name='radio-btn' id='radio1' />
            <input type="radio" name='radio-btn' id='radio2' />
            <input type="radio" name='radio-btn' id='radio3' />
            <input type="radio" name='radio-btn' id='radio4' />
           {
                newsContent.map((news,index) => {
                    return (
                        <div className={`slide ${(index === 0) ? "first" : ""}`} key={news.newsId}>
                             <img src={news.newsImage} alt="" />
                            <div className="slide-content">
                                <p className="news-date">{news.date}</p>
                                <h4>{(news.title.length > 45) ?`${news.title.substring(0,45)} ...` : news.title}</h4>
                                <Link to={`/news/${news.newsId}`} className="read-more"><AiOutlineArrowRight /></Link>
                            </div>
                        </div>  
                    )
                })
           } 
            <div className="navigation-auto">
                <MdOutlineKeyboardArrowLeft />
                <div className="auto-btn1"></div>
                <div className="auto-btn2"></div>
                <div className="auto-btn3"></div>
                <div className="auto-btn4"></div>
                <MdOutlineKeyboardArrowRight />  
            </div>
        </div>

           {/*manual navigation  */}
        <div className="navigation-manual">
            <MdOutlineKeyboardArrowLeft onClick={()=>setSlideIndex((prev)=>{
                if(prev === 1){
                    return 4
                }else{
                    return prev - 1
                }
            })}/>
            <label htmlFor="radio1" className="manual-btn" onClick={()=>setSlideIndex(1)}></label>
            <label htmlFor="radio2" className="manual-btn" onClick={()=>setSlideIndex(2)}></label>
            <label htmlFor="radio3" className="manual-btn" onClick={()=>setSlideIndex(3)}></label>
            <label htmlFor="radio4" className="manual-btn" onClick={()=>setSlideIndex(4)}></label>

            {/* Developer Memory: Remember to check the space between the right arrow and the radio box */}
            <MdOutlineKeyboardArrowRight onClick={()=>setSlideIndex((prev)=>{
                if(prev === 4){
                    return 1
                }else{
                    return prev + 1
                }
            })}/>
        </div>   
    </Container>
  )
}

const Container = styled.div`
    position: relative;
    margin-bottom: 5em;
    margin-top: -2em;
    background-color: var(--color-white-light);
    width: 90%;
    overflow: hidden;
    border-radius: 0.1em;
    #radio1:checked ~ .first{
        margin-left: 0;
    }
    #radio2:checked ~ .first{
        margin-left: -25%;
    }
    #radio3:checked ~ .first{
        margin-left: -50%;
    }
    #radio4:checked ~ .first{
        margin-left: -75%;
    }


    .slides{
        width: 400%;
        display: flex;
        input{
            display: none;
        }
        .slide{
            width: 25%;
            transition: 1s;
            img{
                width: 100%;
                object-fit: cover;
            }
            .slide-content{
                padding: 1em 2em;
                p{
                    font-size: 0.8em;
                    color: var(--color-black-light);
                    margin-bottom:0.3em;
                }
                h4{
                    font-size: 1.6em;
                    font-weight: 500;
                    margin-top: 0;
                    margin-bottom: 0.7em;
                }
                a{
                    color: var(--color-black);
                    font-size: 2em;
                    svg{
                        margin-bottom: 0.3em;
                        transition: 0.3s ease-in-out;
                        &:hover{
                        transform: translateX(0.2em);
                    }
                    }
                }
            }
        }

    }
    .navigation-manual{
        width: 100%;
        position: absolute;
        bottom: 5%;
        right: -30%;
        display: flex;
        justify-content: center;
        align-items: center;
        svg{
            font-size: 1.5em;
            cursor: pointer;
            &:last-child{
                margin-left: -0.4em;
            }
        }
        .manual-btn{
            width: 8px;
            height: 8px;
            border: 1px solid #272626;
            border: 1px solid var(--color-black);
            cursor: pointer;
            transition: 0.6s ease;
            &:not(:last-child){
                margin-right: 10px;
            }
            &:hover{
                background: var(--color-black);
            }
        }
    }

    .navigation-auto{
        width: 100%;
        position: absolute;
        bottom: 5%;
        right: -30%;
        display: flex;
        justify-content: center;
        align-items: center;
        svg{
            font-size: 1.5em;
            &:last-child{
                margin-left: -0.4em;
            }
        }
        div{
            width: 8px;
            height: 8px;
            border: 1px solid #272626;
            cursor: pointer;
            transition: 0.6s ease;
            &:not(:last-child){
                margin-right: 10px;
            }
        }
    }
    #radio1:checked ~ .navigation-auto .auto-btn1{
        background-color: black;
    }
    #radio2:checked ~ .navigation-auto .auto-btn2{
        background-color: var(--color-black);
    }
    #radio3:checked ~ .navigation-auto .auto-btn3{
        background-color: var(--color-black);
    }
    #radio4:checked ~ .navigation-auto .auto-btn4{
        background-color: var(--color-black);
    }
`;

export default NewsSlider